import { Headline } from 'ui/Styled/Styled';

import { FC } from 'react';
import * as S from '../Documents.styled';
import { S as TableS } from 'ui/Table';
import { getTranslated } from 'messages';
import Button from 'ui/Button/Button';
import { RouterPaths } from 'helpers/router-paths';
import { ReactComponent as LockIcon } from 'assets/lock-alt.svg';
import { ReactComponent as UnlockIcon } from 'assets/unlock-alt.svg';
import { DocumentType, FileExtensionType, HistoryDocumentModel } from 'api/api';
import ButtonsContainer from 'ui/Button/ButtonContainer';
import { usePopup } from 'components/Popup';
type DocumentRowProps = {
    assignmentId: number;
    locked: boolean;
    document: DocumentType;
    data: HistoryDocumentModel[];
    isPaid: boolean;
    openPaymentPopup: () => void;
    isAdmin: boolean;
};

export const DocumentRow: FC<DocumentRowProps> = ({
    document,
    locked,
    data,
    isPaid,
    assignmentId,
    isAdmin,
    openPaymentPopup
}) => {
    const openDownloadPopup = usePopup(
        data.length > 0 && <DocumentDownloadPopupContent data={data} />
    );

    return (
        <TableS.RowContainer key={document}>
            <TableS.Row>
                <S.DocumentRowLabel>
                    {locked ? <LockIcon /> : <UnlockIcon />}
                    {getTranslated('issuedDocuments', document)}
                </S.DocumentRowLabel>
                <S.DocumentRowButton>
                    {!isPaid ? (
                        <Button icon="payment" onClick={openPaymentPopup}>
                            Оплатить
                        </Button>
                    ) : (
                        <>
                            {locked && (
                                <Button
                                    icon="download"
                                    onClick={openDownloadPopup}
                                >
                                    Скачать
                                </Button>
                            )}
                        </>
                    )}
                    {((!locked && isPaid) || isAdmin) && (
                        <Button
                            icon="info"
                            href={RouterPaths.Document(document, assignmentId)}
                        >
                            Подробнее
                        </Button>
                    )}
                </S.DocumentRowButton>
            </TableS.Row>
        </TableS.RowContainer>
    );
};

type DocumentDownloadPopupContentProps = {
    data: HistoryDocumentModel[];
};

export const DocumentDownloadPopupContent: FC<
    DocumentDownloadPopupContentProps
> = ({ data }) => {
    const pdf = data.find(
        ({ extensionDocuments }) => extensionDocuments === FileExtensionType.Pdf
    );

    const docx = data.find(
        ({ extensionDocuments }) =>
            extensionDocuments === FileExtensionType.Docx
    );

    return (
        <>
            <Headline>Выберите тип файла</Headline>
            <ButtonsContainer>
                {pdf?.file?.url && (
                    <Button view="pdf" href={pdf.file.url} download>
                        Скачать PDF
                    </Button>
                )}
                {docx?.file?.url && (
                    <Button view="word" href={docx.file.url} download>
                        Скачать Word
                    </Button>
                )}
            </ButtonsContainer>
        </>
    );
};
